import React from 'react'
import BusinessDetailsPage from './BusinessDetailsPage'
import AgreementDetailsPage from './AgreementDetailsPage'
import { useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { GET_FRANCHISE } from '../../../graphql/query'

// type Props = {
//   data: any
// }

const ManageAgreement = () => {
  const params = useParams()
  const uuid: any = params.uuid
  const { data, loading, error } = useQuery(GET_FRANCHISE, {
    variables: {
      input: {
        franchiseId: parseInt(uuid)
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Franchise'
      }
    }
  })

  console.log(uuid)
  if (data) {
    console.log(data)
  }

  if (error) {
    console.log(error)
  }

  if (loading) {
    return <>Loading....</>
  }
  return (
    <div>
      <BusinessDetailsPage data={data} />
      <br />
      <AgreementDetailsPage data={data} />
    </div>
  )
}

export default ManageAgreement
